/* Single source of truth for brand constants used in static copy (the API /content carries the same values). */
export const HOTEL = {
  name: "Skånevik Fjordhotel",
  short: "Fjordhotellet",
  phone: "+47 917 03 536",
  phoneDisplay: "917 03 536",
  tel: "tel:+4791703536",
  email: "post@fjordhotellet.no",
  street: "Strondavegen 2695",
  postal: "5593 Skånevik",
  address: "Strondavegen 2695, 5593 Skånevik",
  facebook: "https://www.facebook.com/Fjordhotellet/",
  instagram: "https://www.instagram.com/fjordhotellet/",
  lat: 59.7297,
  lng: 5.8844,
  mapsUrl: "https://www.google.com/maps/dir/?api=1&destination=Strondavegen+2695,+5593+Sk%C3%A5nevik",
  domain: "fjordhotellet.no",
};
